/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, synced: NonNullable<unknown> }} Settings_Contacts_StatusInputs */

const en_settings_contacts_status = /** @type {(inputs: Settings_Contacts_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} cached · last synced ${i?.synced}`)
};

const he_settings_contacts_status = /** @type {(inputs: Settings_Contacts_StatusInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} שמורים · סונכרן לאחרונה ${i?.synced}`)
};

/**
* | output |
* | --- |
* | "{count} cached · last synced {synced}" |
*
* @param {Settings_Contacts_StatusInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_contacts_status = /** @type {((inputs: Settings_Contacts_StatusInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Contacts_StatusInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_contacts_status(inputs)
	return he_settings_contacts_status(inputs)
});